import React from 'react';

const Payment = () => {
    return (
        <div>
              <h4 className='section-heading fw-bold text-center mt-5 mb-3'>Payment System Coming soon !!!!</h4>
        </div>
    );
};

export default Payment;